import axios from "axios";
import WS from "./ws";

const instance = axios.create({
    baseURL: process.env.REACT_APP_LINK_API,
    headers: {"Content-Type": "application/json"},
});

// Header por-request: token do owner, com fallback pra sessão de operador.
// O `if (!config.headers.Authorization)` preserva os headers setados à mão em
// createMessage/updateMessage/editCampaign. Nunca emite "Bearer " vazio.
instance.interceptors.request.use((config) => {
    const tk = localStorage.getItem("token") || localStorage.getItem("operator_session_token");
    if (tk && !config.headers.Authorization) config.headers.Authorization = `Bearer ${tk}`;
    return config;
});

// 401 numa sessão de operador (sem token de owner) = chave expirada/revogada:
// limpa a sessão, fecha o WS e manda pro login do operador da campanha da URL.
// Owner 401 e 403 (endpoints owner-only) não entram aqui — sem loop de redirect.
instance.interceptors.response.use(
    (res) => res,
    (error) => {
        const status = error?.response?.status;
        const token = localStorage.getItem("token");
        const operator = localStorage.getItem("operator_session_token");
        if (status === 401 && !token && operator) {
            localStorage.removeItem("operator_session_token");
            WS.close();
            const m = window.location.pathname.match(/\/campaign\/([^/]+)/);
            window.location = m ? `/operator/login/${m[1]}` : "/";
        }
        return Promise.reject(error);
    },
);

export default instance;
